import { Auth } from "aws-amplify";
import { useEffect, useState } from "react";
import { user, isAuth as isAuthVar, cognitoUser } from "./apollo/cache";
import { Hub } from "aws-amplify";
import { useApolloClient, ApolloProvider, useReactiveVar } from "@apollo/client";
import { clientIAM } from "./apollo/client";
// import axios from "axios";
import { useTranslation } from "react-i18next";
import { checkLanguage } from "utility";

import ReactGA from "react-ga4";
import useFlag from "state/useFlag";
import { useDispatch } from "redux/store";
import { setPermission } from "redux/slices/role";
import { GetUserDocument } from "__generated__/graphql";

import { TrackJS } from "trackjs";

const GetData = ({ children }) => {
  const client = useApolloClient();
  const isAuth = useReactiveVar(isAuthVar);
  const [isLoading, setIsLoading] = useState(true);
  const { i18n } = useTranslation("", { useSuspense: false });
  const { setFlagsState } = useFlag();
  const dispatch = useDispatch();

  const clearState = () => {
    user(null);
    isAuthVar(false);
    cognitoUser(null);
  };

  const getAuth = async () => {
    try {
      const data = await Auth.currentAuthenticatedUser({ bypassCache: false });
      const profile = await client.query({
        query: GetUserDocument,
        fetchPolicy: "network-only",
      });

      if (!localStorage.checkDefaultLanguage && profile.data?.getUser?.defaultLanguage) {
        i18n.changeLanguage(checkLanguage(profile.data.getUser.defaultLanguage));
        localStorage.checkDefaultLanguage = "done";
      }

      const result = profile.data.getUser;
      user({
        ...result,
        username: result.username,
        attributes: {
          email: data.attributes.email,
          name: "easyrice_name",
          signature: "",
          phoneNumber: "0908121314",
          ...result.attributes,
        },
      });
      TrackJS.addMetadata("username", result.username);
      await dispatch(
        setPermission({
          ...result.role,
        })
      );
      // await dispatch(setPermission("role-test",{
      //   action: [
      //     "user_management:view",
      //     "user_management:edit",
      //     "rice_inspection:view",
      //     "rice_inspection:create",
      //     "rice_inspection:edit",
      //     "rice_inspection:delete",
      //     "rice_inspection:approve",
      //     "rice_inspection:share",
      //     "rice_inspection:option.auto_yellow",
      //     // "rice_inspection:option.average_length",
      //     "rice_inspection.setting:view",
      //     // "rice_inspection.setting:standard.edit",
      //     // "rice_inspection.setting:share",
      //     "rice_inspection.setting:inspection.edit",
      //     "social:line",
      //     "notification:view",
      //     "dashboard:view"
      //   ],
      //   feature: [
      //     "user_management",
      //     "rice_inspection",
      //     "rice_inspection.setting",
      //     "setting",
      //     "social",
      //     "notification",
      //     "web",
      //     "dashboard",
      //   ],
      // }));
      cognitoUser(data);
      setFlagsState({
        isFeedbackShowUp: profile.data.getUser?.isFeedbackShowUp ?? false,
        isShowInfoVersion: profile.data.getUser?.isShowInfoVersion ?? false,
        ...profile.data.getUser?.flags,
      });
      isAuthVar(true);
    } catch (error) {
      // delete axios.defaults.headers.common['Authorization']
      clearState();
    }
  };

  useEffect(() => {
    getAuth().finally(() => setIsLoading(false));
    return function cleanup() {};
  }, []);

  useEffect(() => {
    if (isAuth) {
      ReactGA.set({ userId: user().username });
    }
    return function cleanup() {};
  }, [isAuth]);

  Hub.listen("auth", (data) => {
    if (data.payload.event === "signIn") {
      getAuth().finally(() => setIsLoading(false));
    }
    if (data.payload.event === "signOut") {
      clearState();
    }
  });

  if (isLoading) {
    return (
      <>
        <div />
      </>
    );
  } else {
    return (
      <>
        {isAuth ? <>{children}</> : <ApolloProvider client={clientIAM}>{children}</ApolloProvider>}
      </>
    );
  }
};

export default GetData;
